import { MessageCircle } from "lucide-react";

export const WhatsAppFloat = () => {
  const message = encodeURIComponent(
    "Salve, vorrei informazioni per una prenotazione presso Hotel Due Pini Conte."
  );

  return (
    <a
      href={`https://wa.me/393880925320?text=${message}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Contattaci su WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white shadow-xl flex items-center justify-center hover:scale-110 hover:shadow-2xl transition-transform"
      style={{ boxShadow: "0 8px 24px rgba(37,211,102,0.45)" }}
    >
      <span
        className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping"
        aria-hidden="true"
      />
      <MessageCircle className="w-7 h-7 relative" fill="white" strokeWidth={0} />
    </a>
  );
};
